const defaults = {
  symbol: "SEK",
  thousandsSeparator: ",",
  fractionCount: 2,
  fractionSeparator: ".",
  symbolPosition: "before",
  symbolSpacing: true,
};

const toFixed = (value, precision) => {
  const exponential = Number(`${Number(value)}e${precision}`);
  const rounded = Math.round(exponential);
  return Number(`${rounded}e-${precision}`).toFixed(precision);
};

const formatNumber = (value, options) => {
  const number = Number(value) || 0;
  const fixed = toFixed(Math.abs(number), options.fractionCount);
  const [integer, fraction] = fixed.split(".");
  const grouped = integer.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    options.thousandsSeparator
  );

  return options.fractionCount > 0
    ? `${grouped}${options.fractionSeparator}${fraction}`
    : grouped;
};

export const createCurrencyFormatter = (config = {}) => {
  const options = { ...defaults, ...config };

  return (value, symbol = options.symbol) => {
    const isNegative = String(value).charAt(0) === "-";
    const unsignedValue = isNegative ? String(value).slice(1) : value;
    const amount = Number.parseFloat(unsignedValue);
    const formattedValue = formatNumber(
      Number.isNaN(amount) ? 0 : amount,
      options
    );
    const spacing = options.symbolSpacing ? " " : "";
    const result =
      options.symbolPosition === "front"
        ? `${symbol}${spacing}${formattedValue}`
        : `${formattedValue}${spacing}${symbol}`;

    return isNegative ? `-${result}` : result;
  };
};
